import api from '@/api';
import OpticalPathQuestionSelector from '@/components/editor/OpticalPathQuestionSelector.vue';
import OpticalPathBoard from '@/components/subject/OpticalPathInference/OpticalPathBoard.vue';
export default {
  name: 'OpticalPathQuestionEditor',
  components: {
    OpticalPathQuestionSelector,
    OpticalPathBoard
  },
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      questions: [],
      drawerVisible: false,
      updateIndex: 0
    };
  },
  methods: {
    images(value) {
      try {
        return value ? JSON.parse(value) : [];
      } catch (e) {
        return [];
      }
    },
    config(question) {
      if (!question?.opticalConfig) return null;
      try {
        return typeof question.opticalConfig === 'string' ? JSON.parse(question.opticalConfig) : question.opticalConfig;
      } catch (e) {
        return null;
      }
    },
    choose(index) {
      this.updateIndex = index;
      this.drawerVisible = true;
    },
    onSelected(questionId) {
      api.updateTplQuestionId({
        tplId: this.data.id,
        updateIndex: this.updateIndex,
        questionId
      }).then(() => {
        this.drawerVisible = false;
        this.fetchQuestions();
      });
    },
    fetchQuestions() {
      api.previewTplQuestion(this.data.id).then(questions => {
        this.questions = questions;
      });
    }
  },
  mounted() {
    this.fetchQuestions();
  }
};